import {CoinsFeatureInfo} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coins_feature_info.types';
import {useTranslation} from '@aboutyou/i18n';
import {AboutYouSVGLogo, SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import coinsBackgroundLight from '../../assets/background-light.png';
import {CoinsFeatureInfos} from './CoinsFeatureInfos';

export const CoinsDisclaimer: React.FC<{
  className?: string;
  title?: string;
  featureInfos: CoinsFeatureInfo[];
}> = ({className, title, featureInfos}) => {
  const {t} = useTranslation();

  return (
    <Wrapper className={className} data-testid="coinsWalletDisclaimer">
      <LogoWrapper>
        <AboutYouSVGLogo disableLogoLink />
        <Text size="px24" weight="heavy">
          {title || t('Coins')}
        </Text>
      </LogoWrapper>
      <CoinsFeatureInfos featureInfos={featureInfos} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 60px 24px;
  border-radius: 16px;
  background: url(${coinsBackgroundLight});
  background-size: cover;
  margin-top: ${SPACING['Y.Lg']};
`;

const LogoWrapper = styled.div`
  display: flex;
  gap: 9px;
`;
